import { identity } from "../../function/identity.mjs";
import { mapKeys as mapKeys$1 } from "../../object/mapKeys.mjs";
import { iteratee } from "../util/iteratee.mjs";
//#region src/compat/object/mapKeys.ts
/**
* Creates a new object with the same values as the given object, but with keys generated
* by running each own enumerable property of the object through the iteratee function.
*
* @template T - The type of the object.
* @template K1 - The type of the keys in the object.
* @template K2 - The type of the new keys generated by the iteratee function.
*
* @param {T} object - The object to iterate over.
* @param {(value: T[K1], key: K1, object: T) => K2} [getNewKey] - The function invoked per own enumerable property, or a path to generate new keys.
* @returns {Record<K2, T[K1]>} - Returns the new mapped object.
*
* @example
* // Example usage:
* const obj = { a: 1, b: 2 };
* const result = mapKeys(obj, (value, key) => key + value);
* console.log(result); // { a1: 1, b2: 2 }
*/
function mapKeys(object, getNewKey = identity) {
	if (object == null) return {};
	return mapKeys$1(object, iteratee(getNewKey));
}
//#endregion
export { mapKeys };
